import gql from 'graphql-tag';

const GET_COUNT_ORDERS = gql`
    query getCountOrders ($range: [RangeInput], $filters: [FilterInput]) {
        getCountOrders (range: $range, filters: $filters) {
            count
        }
    }
`;

export default GET_COUNT_ORDERS;
